export type Token =
    | { type: 'command'; value: string }
    | { type: 'brace'; value: '{' | '}' | '[' | ']' }
    | { type: 'symbol'; value: string }
    | { type: 'parentheses'; value: '(' | ')' };

// Convert LaTeX string into actionable tokens
export function tokenize(input: string): Token[] {
    const tokens: Token[] = [];
    let i = 0;

    while (i < input.length) {
        const char = input[i];

        if (char === '\\') {
            const match = input.slice(i + 1).match(/^[a-z]+/i);
            if (match) {
                tokens.push({ type: 'command', value: match[0] });
                i += match[0].length + 1;
                continue;
            }
        }

        if (char === '{' || char === '}' || char === '[' || char === ']') {
            tokens.push({ type: 'brace', value: char });
            i++;
            continue;
        }

        if (char === '^') {
            tokens.push({ type: 'command', value: '^' });
            i++;
            continue;
        }

        if (char === '(' || char === ')') {
            tokens.push({ type: 'parentheses', value: char });
            i++;
            continue;
        }

        if (input.startsWith('\\left', i)) {
            tokens.push({ type: 'command', value: '\\left' });
            i += 5;
            continue;
        }
        if (input.startsWith('\\right', i)) {
            tokens.push({ type: 'command', value: '\\right' });
            i += 6;
            continue;
        }

        // fallback: plain symbol (a-z, 1-9, etc.)
        tokens.push({ type: 'symbol', value: char });
        i++;
    }

    return tokens;
}
